import { sortNumber } from '../../utils/sort/sortNumber';
import { sortNumberOrString } from '../../utils/sort/sortNumberOrString';
import { sortNumberWithPrefix } from '../../utils/sort/sortNumberWithPrefix';
import { sortString } from '../../utils/sort/sortString';
import { DataMainBoardResponse } from '../depreciation/types';
import { OrderType, SortRows } from '../schemas';

type DataMainBoardTable = DataMainBoardResponse['data'];

export const sortMainBoard = (
  tableData: DataMainBoardTable,
  order: OrderType,
  sort: string
): DataMainBoardTable => {
  if (!tableData) {
    return tableData;
  }

  // sortの文字列とcolumnsのcodeが一致するindexを取得
  const sortIndex = tableData.columns.findIndex((column) => {
    return column.code === sort;
  });

  // sortの文字列とcolumnsのcodeが一致するtypeを取得
  const sortType = tableData.columns.find((column) => {
    return column.code === sort;
  });

  if (sortIndex == null || sortType == null) {
    return tableData;
  }

  type RowType = DataMainBoardTable['rows'][number];

  // ソートユーティリティはSortRows型を期待するため型アサーションを使用
  // DataMainBoardのrowsはdataプロパティを持つため互換性がある
  const rowsForSort = tableData.rows as unknown as SortRows[];
  let sortRows: SortRows[];

  switch (sortType.type) {
    case 'string':
      sortRows = sortString<SortRows>(rowsForSort, sortIndex, order);
      break;
    case 'number':
      sortRows = sortNumber<SortRows>(rowsForSort, sortIndex, order);
      break;
    case 'numberWithPrefix':
      sortRows = sortNumberWithPrefix<SortRows>(rowsForSort, sortIndex, order);
      break;
    case 'numberOrString':
      sortRows = sortNumberOrString<SortRows>(rowsForSort, sortIndex, order);
      break;
    default:
      return tableData;
  }

  return {
    ...tableData,
    rows: sortRows as unknown as RowType[],
  };
};
